<div class="manage-tax-agents-container" *ngIf="!showAppointTax">
    <div class="tab-navigation">
        <div class="nav-container">
            <div class="tabs-section">
                <button *ngFor="let tab of getTabs(); let i = index" class="tab-button"
                    [class.active]="selectedTabIndex === i" (click)="selectTab(i, tab)">
                    {{ tab }}
                </button>
            </div>
            <div class="controls-section">
                <div class="filter-search-row" *ngIf="shouldShowTopSearchRow()">
                    <div class="filters-section" #filterTrigger>
                        <!-- <span class="textHover" (click)="toggleLevelFilterPopover($event)">
                            <span class="filter-text">Filters</span>
                            <mat-icon class="filter-icon">filter_alt</mat-icon>
                        </span>
                        <app-filter-popover class="filter-popover" *ngIf="showLevelFilterPopover"
                            [options]="levelFilterOptions" [selected]="selectedLevels"
                            (apply)="onLevelFilterApply($event)" (reset)="onLevelFilterReset()"
                            (cancel)="closeLevelFilterPopover()" (click)="$event.stopPropagation()">
                        </app-filter-popover> -->
                    </div>

                    <div class="search-box">
                        <input type="text" class="search" placeholder="Search" [(ngModel)]="searchText"
                            (keyup)="searchPrediction($event)" (ngModelChange)="onFilterChange()"
                            (contextmenu)="preventContext($event)" (drop)="preventDrop($event)" />
                        <mat-icon class="search-icon" (click)="searchText ? clearText() : search()">
                            {{ searchText ? 'close' : 'search' }}
                        </mat-icon>
                    </div>
                </div>

                <div class="button-row" *ngIf="shouldShowTopActionButtons()">
                    <button *ngFor="let btn of data?.[0]?.buttons || []" type="button" (click)="handleButtonClick(btn)"
                        [class]="btn.class">
                        {{ btn.text }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="tab-content" *ngIf="!showAppointTax">
    <div *ngFor="let tab of getTabs(); let i = index" [class.active-tab]="selectedTabIndex === i" class="tab-panel">

        <div class="content-area">
            <ng-container *ngIf="selectedTabIndex === i && tab === 'Tax Representative'"
                [ngComponentOutlet]="searchTaxAgentsComponent"></ng-container>
            <ng-container [ngSwitch]="tab">
                <div *ngSwitchCase="'Tax Representative'">
                    <app-table *ngIf="tableData" [tableInfo]="tableData.header"
                        [showFilter]="false" [showActionIcons]="true" [tableType]="tableData.tableType"
                        [displayedColumns]="tableData.tableHeadings" [sortableFields]="tableData.sortableFields"
                        [tableData]="tableData.tableData" [dataLoadComplete]="!isLoadingData"
                        (filtersCleared)="onTableFiltersCleared()" [tableUrls]="tableData.tableUrls"
                        [load]="isLoadingData" [externalSearchText]="searchText"
                        [externalActiveFiltersCount]="selectedLevels.size"></app-table>
                    <div *ngIf="!tableData" class="loading-message">
                    Loading Tax Representative data...
                    </div>
                </div>

                <div *ngSwitchCase="'Authorization Level Details'" class="auth-level-details">
                    <div class="mt-4">
                        <app-para *ngIf="authLevelDetails?.paragraphs" [para]="authLevelDetails.paragraphs"></app-para>
                        <app-table *ngIf="authLevelDetails?.tableData"
                            [tableType]="authLevelDetails.tableData.tableType"
                            [displayedColumns]="authLevelDetails.tableData.tableHeadings"
                            [tableData]="authLevelDetails.tableData.tableData" [dataLoadComplete]="!isLoadingData"
                            (filtersCleared)="onTableFiltersCleared()" [load]="isLoadingData" [noPagination]="false"
                            [externalSearchText]="searchText" [externalActiveFiltersCount]="selectedLevels.size"></app-table>
                        <div *ngIf="!authLevelDetails" class="loading-message">
                            Loading authorization level details...
                        </div>
                    </div>
                </div>

                <div *ngSwitchCase="'Active Tickets'">
                    <div class="mt-4">
                        <app-table *ngIf="getCurrentTabData()" [tableType]="getCurrentTabData().tableType"
                                [displayedColumns]="getCurrentTabData().tableHeadings"
                                [dataLoadComplete]="!isLoadingData"
                                [tableData]="getCurrentTabData().tableData"
                                [sortableFields]="getCurrentTabData().sortableFields"
                                [tableUrls]="getCurrentTabData().tableUrls" [showFilter]="false" [showActionIcons]="false"
                                [showPagination]="true" [load]="isLoadingData" [externalSearchText]="searchText"
                                [externalActiveFiltersCount]="selectedLevels.size">
                            </app-table>
                    </div>
                </div>

                <div *ngSwitchDefault>
                    <div class="default-content">
                        <p>{{ tab.content || 'Content not available' }}</p>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>
</div>